import React, { useEffect, useState } from "react";

const ProfilePage = () => {
  const [user, setUserDetails] = useState(false);

  useEffect(() => {
    if (window.location.toString().includes("user")) {
      let userDetailss = localStorage.getItem("userDetails");
      if (userDetailss) {
        setUserDetails(JSON.parse(userDetailss));
      }
    }
  }, []);

  return (
    <div className="container mt-2">
      <div className="row">
        <div className="col-md-12 mx-auto">
          <ul className="list-group list-group-flush mb-3 bg-white">
            <li className="list-group-item py-3 bg-white">
              <strong>Username:</strong> {user.username}
            </li>
            <li className="list-group-item py-3 bg-white">
              <strong>First name:</strong> {user.firstName || "N/A"}
            </li>
            <li className="list-group-item py-3 bg-white">
              <strong>Middle name:</strong> {user.middleName || "N/A"}
            </li>
            <li className="list-group-item py-3 bg-white">
              <strong>Last name:</strong> {user.lastName || "N/A"}
            </li>
            <li className="list-group-item py-3 bg-white">
              <strong>Date of Birth:</strong> {user.DOB || "N/A"}
            </li>
            <li className="list-group-item py-3 bg-white">
              <strong>Father name:</strong> {user.fatherName || "N/A"}
            </li>
            <li className="list-group-item py-3 bg-white">
              <strong>Email:</strong> {user.email || "N/A"}
            </li>
            <li className="list-group-item py-3 bg-white">
              <strong>Mobile:</strong> {user.mobile || "N/A"}
            </li>
            <li className="list-group-item py-3 bg-white">
              <strong>Alternate mobile:</strong> {user.alretnateNumber || "N/A"}
            </li>
            <li className="list-group-item py-3 bg-white">
              <strong>Board:</strong> {user.category || "N/A"}
            </li>
            <li className="list-group-item py-3 bg-white">
              <strong>Grade:</strong> {user.grade || "N/A"}
            </li>
            <li className="list-group-item py-3 bg-white">
              <strong>School:</strong> {user.school || "N/A"}
            </li>
            <li className="list-group-item py-3 bg-white">
              <strong>Address:</strong> {user.address || "N/A"}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
